import React from 'react';
import { Input } from 'rsuite';
import { Label } from '../Label';

import './styles.css';

/**
 * Custom Toggle component that applies the primary color of the custom theme to the checked state.
 * @component
 * @param {import('rsuite').InputProps} props - Additional props to pass to the Toggle component.
 * @returns {JSX.Element} CustomToggle component.
 */

export function CustomInput({ label, ...props }) {
  return (
    <div style={{ width: '100%' }}>
      {Boolean(label) && <Label htmlFor={props?.id}>{label}</Label>}
      <Input {...props} className="custom-input" />
    </div>
  );
}
